<script setup lang="ts">
import { computed } from "vue";
import { ratingRange, type Field } from "@yawhub/core";
const props = defineProps<{ fields: Field[]; columns: string[] }>();
const bars = defineModel<string[]>("bars", { required: true });
const updated = defineModel<boolean>("updated", { required: true });
const scales = computed(() =>
  props.fields.filter(
    (f) => f.active && f.type === "rating" && props.columns.includes(f.id),
  ),
);
function setDisplay(id: string, value: string) {
  bars.value = [
    ...bars.value.filter((v) => v !== id),
    ...(value === "bar" ? [id] : []),
  ];
}
</script>
<template>
  <details class="table-appearance">
    <summary>
      Visning af værdier
      <span class="muted"
        >{{ bars.length ? "Skalaer som barer" : "Feltets visning" }} ·
        {{ updated ? "med" : "uden" }} ændringstid</span
      >
    </summary>
    <div class="appearance-options">
      <label v-for="f in scales" :key="f.id">
        {{ f.label }}
        <span class="muted"
          >{{ ratingRange(f).min }}–{{ ratingRange(f).max }}</span
        >
        <select
          :aria-label="'Vis ' + f.label + ' som'"
          :value="bars.includes(f.id) ? 'bar' : 'number'"
          @change="setDisplay(f.id, ($event.target as HTMLSelectElement).value)"
        >
          <option value="number">Feltets visning</option>
          <option value="bar">Opdelt bar og tal</option>
        </select>
      </label>
      <label class="checkbox"
        ><input type="checkbox" v-model="updated" />Vis senest opdateret</label
      >
      <p class="muted small">
        Tidspunktet viser seneste ændring i Yawhub. En uændret import flytter
        det ikke.
      </p>
    </div>
  </details>
</template>
<style
  scoped
  lang="scss"
  src="../styles/components/TableAppearance.scss"
></style>
